import {cx} from "class-variance-authority";
import {Loader} from "lucide-react";

export const Button = ({as="button", className, children, isLoading, variant = "primary", ...props}) => {
    let classByVariant = "";
    if (variant === "primary") {
        classByVariant = "bg-indigo-500 hover:bg-indigo-600 focus:ring-indigo-500";
    }
    if (variant === "secondary") {
        classByVariant = "bg-sky-500 hover:bg-sky-600 focus:ring-sky-500";
    }
    if (variant === "danger") {
        classByVariant = "bg-red-500 hover:bg-red-600 focus:ring-red-500";
    }
    if (variant === "success") {
        classByVariant = "bg-green-500 hover:bg-green-600 focus:ring-green-500";
    }
    if (variant === "gray") {
        classByVariant = "bg-gray-500 hover:bg-gray-600 focus:ring-gray-500";
    }
    const Comp = as;
    return (
        <Comp
            {...props}
            disabled={isLoading}
            className={cx(
                "h-[40px] px-4 py-2 text-white rounded-md",
                "focus:outline-none focus:ring-2 focus:ring-opacity-50",
                "transition-colors duration-300 ease-in-out",
                "flex items-center justify-center text-center normal-case",
                className,
                classByVariant
            )}
        >
            {isLoading ? <Loader className="w-6 h-6 animate-spin" /> : children}
        </Comp>
    );
};
